import React, { Component } from "react";
 
class Registration extends Component {
  render() {
    return (
      <div>
        <h2>Zapísanie</h2>
      <p>
      Ovocie môžete zapísať:
      </p>
        <address>
          Telefonicky: +421-948-159-484 <br />
          SMS správou: +421-948-159-484 <br />
          Facebook Messengerom:  <a href="https://www.messenger.com/t/palfygarden">
          m.me/palfygarden</a><br />
          Mailom: <a href="mailto:george.palfy@gmail.com">
          george.palfy@gmail.com</a><br />
        </address>
      </div>
    );
  }
}
 
export default Registration;



// WEBPACK FOOTER //
// ./src/Registration.js